// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wD8xk","top":"styles_top__jpNyU","right":"styles_right__4QU9V","bottom":"styles_bottom__ClVLP","left":"styles_left__OTL0j","active":"styles_active__9Bcs8"};